import {
  ADD_MESSAGE_SAVE,
  ADD_MESSAGE_ERROR,
  CLEAR_MESSAGE
} from "../Constants";

const initialMessageState = {
  payload: [],
  cssClass: ""
};

export default (state = initialMessageState, action) => {
  switch (action.type) {
    case ADD_MESSAGE_SAVE:
      return {
        payload: action.msgs,
        cssClass: "SUCCESS"
      };
    case ADD_MESSAGE_ERROR:
      return {
        payload: action.msgs,
        cssClass: "ERROR"
      };
    case CLEAR_MESSAGE:
      return {
        payload: action.msgs
      };
    default:
      return state;
  }
};
